module.exports = __webpack_public_path__ + "static/xamp-start-a5cde95cdbcf4c459656935e502b2380.png";